import React, { Suspense } from "react";
import { Helmet } from "react-helmet-async";

import { LoginContainer } from "../Containers/Login";
export const LoginPage = () => {
  return (
    <Suspense fallback={"loading"}>
      <Helmet>
        <title>Авторизация | Система конкурсного отбора претендентов по стипендии «Болашак»</title>
      </Helmet>
      <LoginContainer />
    </Suspense>
  );
};
